<!-- this component takes an job formgroup and displays the job additional fields accordingly -->
<ng-container *ngIf="jobFormGroup" [formGroup]="jobFormGroup">
    <div class="job-additional-fields" formArrayName="fields">
        <div
            class="job-article-field-wrap"
            [ngClass]="{ 'field-group': jobField.get('type').value === 'group' }"
            *ngFor="let jobField of getJobFieldsFormArray().controls"
        >
            <ng-container *ngIf="publicView; else normalArticleView">
                <ng-container *ngIf="!utils.notAllowedFileTypesForPublicView.includes(jobField.get('type').value)">
                    <ng-container [ngTemplateOutlet]="articleFieldHtml"></ng-container>
                </ng-container>
            </ng-container>
            <ng-template #normalArticleView>
                <ng-container [ngTemplateOutlet]="articleFieldHtml"></ng-container>
            </ng-template>

            <ng-template #articleFieldHtml>
                <ng-container *ngIf="fieldVisibilityMapping[jobField.get('_id').value]">
                    <app-job-article-field
                        [publicView]="publicView"
                        [projectId]="projectId"
                        [jobId]="jobId"
                        [fieldFormGroup]="jobField"
                        [changesAllowed]="changesAllowed"
                        [linkFieldRelation]="'job#' + jobId"
                        [asDialog]="asDialog"
                        (articleFieldFormGroupChanged)="calculateFieldVisibility()"
                        (duplicateGroup)="onDuplicateGroup(jobField.get('_id').value)"
                        (deleteDuplicatedGroup)="onDeleteDuplicatedGroup(jobField.get('_id').value)"
                    ></app-job-article-field>
                </ng-container>
            </ng-template>
        </div>
    </div>
</ng-container>
